import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/user/userSlice";
import insightReducer from "../features/insight/insightSlice";

const store = configureStore({
    reducer: {
        userLogin: userReducer,
        insights: insightReducer,
    },
});

export default store;
